module.exports = __webpack_public_path__ + "img/SketchPng225d4c05e4b7a3d989f84e041a2250e4a20b8e49b0b1549a2aab7767c3dbe871.df82f01c.png";